import styled from 'styled-components6';
import { useGlobal } from '../../hooks';
import { normalizeLinks } from 'rwl-ui/src/utils/normalizeContactLinks';
import { ButtonBase, getPageUrl, useAnalyticsClickEvent } from 'rwl-ui';
import { ClickTargets } from 'rwl-shared/dist/models/analytics';

const Container = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px var(--rwl-spacing-lg) 12px var(--rwl-spacing-lg);
`;

const Text = styled.span`
    font-size: 16px;
    font-weight: 600;
`;

const SmallContactButton = styled(ButtonBase).withConfig({
    shouldForwardProp: (prop) => !['brandColor', 'textColor'].includes(prop),
})<{ brandColor?: string; textColor?: string }>`
    border-radius: var(--rwl-radius-lg);
    background-color: ${({ brandColor }) =>
        brandColor || 'var(--rwl-color-primary)'};
    color: ${({ textColor }) => textColor || 'var(--rwl-palette-white)'};
    font-weight: 500;
    cursor: pointer;
    transition: filter 0.2s ease;
    padding: 4px 10px;
    height: 28px;
    min-width: 85px;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
        filter: brightness(0.85);
    }
`;

export const SeeProjectsRow = (): JSX.Element | null => {
    const { config, brandColor, bumpOutTestEnabled, bumpOutTest } = useGlobal();
    const sendClickEvent = useAnalyticsClickEvent();

    if (!config) {
        return null;
    }

    const { contactUs } = normalizeLinks(config?.businessContactInfo);

    const effectiveBrandColor =
        bumpOutTestEnabled && bumpOutTest
            ? bumpOutTest.tabBackgroundColor
            : brandColor;
    const effectiveTextColor =
        bumpOutTestEnabled && bumpOutTest
            ? bumpOutTest.tabTextColor
            : undefined;

    const handleOnClick = () => {
        sendClickEvent({
            url: getPageUrl(),
            target: ClickTargets.CONTACT,
        });
    };

    return (
        <Container>
            <Text>See projects near you</Text>
            {contactUs && (
                <SmallContactButton
                    brandColor={effectiveBrandColor}
                    textColor={effectiveTextColor}
                    href={contactUs}
                    target="_blank"
                    onClick={handleOnClick}
                >
                    Contact us
                </SmallContactButton>
            )}
        </Container>
    );
};
